import React from 'react'
import styled from 'styled-components'
import busImage from '../../../../../assets/img/item_service.png'
import { device } from '../../../../../config/theme/breakpoints'
import ItemOption from '../../../../services/components/item-option/item-option'
import { listOptions } from '../../../data'

const ContainerDetail = styled.div`
    background: #F2F2F2;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    border-radius: 15px;
    margin-left: 10px;
    margin-bottom: 10px;

    @media ${device.tablet}{
        width: 46%;
    }
    
    @media ${device.laptop}{
        width: 32%;
    }
`

const ContainerImage = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
        width: 100%;
        border-radius: 10px 10px 100px 10px;
        width 100%;
        margin: auto;
    }
`
const ContainerOptions = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    flex-wrap: wrap;
    margin-top: 10px;
    padding: 15px 30px;
`

const ItemDetailService: React.FunctionComponent = () => {

  return (
    <ContainerDetail>
        <ContainerImage>
            <img src={busImage} alt='imagen de bus'/>
        </ContainerImage>
        <ContainerOptions>
            {listOptions.map(option => (
                <ItemOption key={option.id} icon={option.icon} name={option.name}/>
            ))}
        </ContainerOptions>
    </ContainerDetail>
  )
}

export default ItemDetailService